//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
      return {
        show: false,
      };
  },
  
  props: {
    email: {
      default: 'info@bpbauto.com.au',
    },
    linkedIn: {},
    permalink: {},
    title: {},
    shareTitle: {
      default: 'Share this article',
    },
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {

  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/PostShare.vue